import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import queryString from 'querystringify';
import Create from './Create';
import { list } from '../../store/actions';
import Tables from '../../components/DynamicTables';

const columns = [
  {
    Header:'Judul / Nama',
    accessor: 'title'
  },
  {
    Header: 'Type ',
    accessor: 'type'
  },
  {
    Header: 'Schedule ',
    accessor: 'schedule_at'
  }
]

class ManajemenNotifikasi extends Component {
  state = {
    isCreate: false,
    originalData: []
  }

  loadModules = (param) => {
    const query = queryString.stringify(param)
    this.props.list({
      name: 'notifications',
      customName: 'post',
      query
    })
  }

  componentDidMount() {
    const { query } = this.props
    this.loadModules(query)
  }

  componentDidUpdate(prevProps) {
    const { query,data } = this.props
    // query.page + 1
    const page = query + 1
    if (prevProps.query !== this.props.query) {
      this.loadModules(query)
    }
  }

  // handleView = (data) => {
  //   const { history } = this.props
  //   const { uuid } = data.original
  //   history.push(`/post/${uuid}`)
  // }
  
  handleCreate = (isCreate) => {
    this.setState({
      isCreate,
    })
  }
  handleUpdate = (data,isUpdate) => {
    let originalData = data && data.original

    this.setState({
      isUpdate,
      originalData: originalData
    })
  }
  render() {
    const { data } = this.props
    let result = (data && data.data.data && data.data.data) || []
    const { isCreate, originalData } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container-fluid">
            <Tables
              withFilter={{ placeHolder: 'Cari Notifikasi'}}
              withSelectRow
              withPagination
              title="Notifikasi"
              name="tasklist" // following the name or customName in this.props.list
              columns={columns}
              withCreate={(isCreate) => this.handleCreate(isCreate)}
              data={result}
            />
            <Create 
              isOpen={isCreate}
              onClose={()=> this.setState({ isCreate: false})}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  return {
    data: state.module.list.post,
    query: state.module.table
  };
};

export default connect(mapStatetoProps, { list })(ManajemenNotifikasi);
